import React from 'react'
import styled from 'styled-components'
import SpeedIcon from '../../../../../../generic/icons/IconLib/TruckIcon'

type Props = {
  status: number
  color?: string
}

const TabIcons = ({status, color="#80E081"}: Props) => {
  return (
    <MainWrapper
      $color={color}
    >
      <SpeedIcon color={color} />
    </MainWrapper>
  )
}
const MainWrapper = styled.div<{$color: string}>`
  display: flex;
  color: ${props => props.$color};
  width: 100%;
  justify-content: center;
  align-items: center;

`
export default TabIcons